// Google Analytics custom event tracking utility
// Only fires events when user has consented to cookies

const GA_ID = 'G-CSCJ17CCQJ';

function isConsentGiven(): boolean {
  return localStorage.getItem('cookie-consent') === 'accepted';
}

function gtag(...args: unknown[]) {
  if (!isConsentGiven()) return;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).gtag?.(...args);
}

// Custom event helpers
export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  gtag('event', eventName, params);
};

// Specific event trackers — conversion events
export const trackSignup = (method: string = 'email') => {
  trackEvent('sign_up', { method });
  // GA4 recommended conversion event
  trackEvent('conversion', { send_to: `${GA_ID}/sign_up`, method });
};

export const trackLogin = (method: string = 'email') => {
  trackEvent('login', { method });
};

export const trackTaskCreated = (priority?: string) => {
  trackEvent('task_created', { priority });
};

export const trackTaskCompleted = (taskId: string) => {
  trackEvent('task_completed', { task_id: taskId });
};

export const trackApprovalSubmitted = (type: string) => {
  trackEvent('approval_submitted', { approval_type: type });
};

export const trackApprovalResolved = (status: 'approved' | 'rejected') => {
  trackEvent('approval_resolved', { resolution: status });
  // Mark approval completion as conversion
  trackEvent('conversion', { send_to: `${GA_ID}/approval_completed`, resolution: status });
};

// Utility to get current consent status
export function getConsentStatus(): 'accepted' | 'denied' | null {
  const consent = localStorage.getItem('cookie-consent');
  if (consent === 'accepted' || consent === 'denied') return consent;
  return null;
}

export const trackPageView = (pagePath: string) => {
  gtag('config', GA_ID, { page_path: pagePath });
};

// Initialize GA based on consent
export function initializeGA() {
  if (!isConsentGiven()) {
    // Revoke consent mode
    gtag('consent', 'default', {
      analytics_storage: 'denied',
    });
    return;
  }

  gtag('consent', 'update', {
    analytics_storage: 'granted',
  });
}

// Grant consent and reload GA
export function grantAnalyticsConsent() {
  localStorage.setItem('cookie-consent', 'accepted');
  gtag('consent', 'update', {
    analytics_storage: 'granted',
  });
}

export function denyAnalyticsConsent() {
  localStorage.setItem('cookie-consent', 'denied');
  gtag('consent', 'update', {
    analytics_storage: 'denied',
  });
}
